var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.value.config.value[0].imageurl || _vm.value.config.value[0].name
      ? _c(
          "div",
          {
            class: ["icon-wrap", "icon-wrap" + _vm.value.config.type],
            style: _vm.Styles,
          },
          [
            _c(
              "div",
              {
                class: [
                  _vm.value.config.bg_style === 2 &&
                    _vm.value.config.bg_image &&
                    "bg-wrap",
                ],
              },
              [
                _vm.value.config.title &&
                _vm.value.config.bg_style === 2 &&
                _vm.value.config.bg_image
                  ? _c(
                      "div",
                      {
                        staticClass: "bg-title",
                        style: {
                          "text-align":
                            _vm.value.config.title_position || "left",
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.value.config.title) + " ")]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "icon-content",
                    class: _vm.iconContentClass,
                    style:
                      _vm.value.config.bg_style === 2 &&
                      _vm.value.config.bg_color
                        ? {
                            "background-color": _vm.value.config.bg_color,
                          }
                        : {},
                  },
                  [
                    _vm.value.config.title &&
                    (_vm.value.config.bg_style !== 2 ||
                      !_vm.value.config.bg_image)
                      ? _c(
                          "div",
                          {
                            staticClass: "title",
                            style: {
                              "text-align":
                                _vm.value.config.title_position || "left",
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.value.config.title) + " ")]
                        )
                      : _vm._e(),
                    _c(
                      "el-carousel",
                      {
                        ref: "carousel",
                        staticClass: "hideDot",
                        attrs: {
                          trigger: "click",
                          autoplay: false,
                          "initial-index": _vm.initialIndex,
                          height: _vm.carouselHeight,
                          arrow:
                            _vm.swiperValues.length < 2 ? "never" : "hover",
                        },
                        on: { change: _vm.changeCarousel },
                      },
                      _vm._l(
                        _vm.swiperValues,
                        function (carouselItem, carouseIndex) {
                          return _c("el-carousel-item", { key: carouseIndex }, [
                            _c(
                              "div",
                              {
                                ref: "icon_draggable",
                                refInFor: true,
                                staticClass: "icon_draggable",
                              },
                              _vm._l(carouselItem, function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    class: [
                                      "item",
                                      "item" + _vm.value.config.cols,
                                      item.type,
                                    ],
                                  },
                                  [
                                    _vm.value.config.enable_dynamic_tags ===
                                      "1" && item.dynamic_tag
                                      ? _c("div", { staticClass: "tag-wrap" }, [
                                          _c("div", { staticClass: "tag" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.dynamic_tag.slice(0, 3)
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                    _c(
                                      "el-image",
                                      {
                                        staticClass: "img",
                                        attrs: {
                                          src: item.imageurl,
                                          fit: "contain",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.toEdit(item)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "image-slot",
                                            attrs: { slot: "error" },
                                            slot: "error",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-more",
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    item.name
                                      ? _c("div", { staticClass: "name" }, [
                                          _vm._v(_vm._s(item.name)),
                                        ])
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                          ])
                        }
                      ),
                      1
                    ),
                    _vm.swiperValues.length > 1
                      ? _c(
                          "div",
                          { staticClass: "dots-wrap" },
                          _vm._l(
                            _vm.swiperValues.length,
                            function (dot, dotIndex) {
                              return _c("div", {
                                key: dot,
                                class: [
                                  "dot",
                                  dotIndex === _vm.initialIndex && "active",
                                ],
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.changeDot(dotIndex)
                                  },
                                },
                              })
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                    _vm.showMore
                      ? _c(
                          "div",
                          {
                            staticClass: "viewMore",
                            on: {
                              click: function ($event) {
                                _vm.isExpand = !_vm.isExpand
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.isExpand
                                    ? _vm.value.config.fold_btn_text
                                    : _vm.value.config.expand_btn_text
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ]
        )
      : _c("div", { staticClass: "empty" }, [
          _c("div", [_vm._v("点击进行金刚区导航配置")]),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }